export default "__VITE_ASSET__lcYJiiPD__"